import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
const RangoEdadForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>

        <FormGroup>
          <label>Etapa</label>
          <Input type='text' {...register("etapa", {required: "Campo obligatorio"})}/>
          {errors.etapa && <p style={{color: 'red'}}>{errors.etapa?.message}</p>}
        </FormGroup>

        <Row>
          <Col>
            <FormGroup>
              <label>Rango inicial</label>
              <Input type='number' {...register("rangoInicial",
                {
                  required: "Campo obligatorio"
                })}/>
              {errors.rangoInicial && <p style={{color: 'red'}}>{errors.rangoInicial?.message}</p>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Rango final</label>
              <Input type='number' {...register("rangoFinal", {required: "Campo obligatorio"})}/>
              {errors.rangoFinal && <p style={{color: 'red'}}>{errors.rangoFinal?.message}</p>}
            </FormGroup>

          </Col>
        </Row>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default RangoEdadForm;
